module.exports = __webpack_public_path__ + "img/gb.386cc387.svg";